import {
  EMAIL_NOTIFICATION_PREFERENCE_REQUEST,
  EMAIL_NOTIFICATION_PREFERENCE_SUCCESS,
  EMAIL_NOTIFICATION_PREFERENCE_ERROR,
  EMAIL_NOTIFICATION_PREFERENCE_SET,
  EMAIL_NOTIFICATION_PREFERENCE_UPDATE_REQUEST,
  EMAIL_NOTIFICATION_PREFERENCE_UPDATE_SUCCESS,
  EMAIL_NOTIFICATION_PREFERENCE_UPDATE_ERROR
} from './email-preference.type'

import ApiRest from '@/api/api-rest'

const state = {
  userEmailNotificationPreferenceStatus: '',
  userEmailNotificationPreferenceUpdateStatus: '',
  userEmailNotificationPreference: {}
}

const getters = {
  userEmailNotificationPreferenceStatus: state =>
    state.userEmailNotificationPreferenceStatus,
  userEmailNotificationPreferenceUpdateStatus: state =>
    state.userEmailNotificationPreferenceUpdateStatus,
  userEmailNotificationPreference: state =>
    state.userEmailNotificationPreference
}

// Best Practice - updates state
const mutations = {
  [EMAIL_NOTIFICATION_PREFERENCE_REQUEST]: state =>
    (state.userEmailNotificationPreferenceStatus = 'loading'),
  [EMAIL_NOTIFICATION_PREFERENCE_SET]: (state, preference) =>
    (state.userEmailNotificationPreference = preference),
  [EMAIL_NOTIFICATION_PREFERENCE_SUCCESS]: state =>
    (state.userEmailNotificationPreferenceStatus = 'saved'),
  [EMAIL_NOTIFICATION_PREFERENCE_ERROR]: (state, errMsg) => {
    state.userEmailNotificationPreferenceStatus = 'error'
  },
  [EMAIL_NOTIFICATION_PREFERENCE_UPDATE_REQUEST]: state =>
    (state.userEmailNotificationPreferenceUpdateStatus = 'loading'),
  [EMAIL_NOTIFICATION_PREFERENCE_UPDATE_SUCCESS]: state =>
    (state.userEmailNotificationPreferenceUpdateStatus = 'saved'),
  [EMAIL_NOTIFICATION_PREFERENCE_UPDATE_ERROR]: (state, errMsg) => {
    state.userEmailNotificationPreferenceUpdateStatus = 'error'
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [EMAIL_NOTIFICATION_PREFERENCE_REQUEST] (context) {
    return new Promise((resolve, reject) => {
      context.commit(EMAIL_NOTIFICATION_PREFERENCE_REQUEST)
      ApiRest()
        .get(`/email/preferences/notification`)
        .then(({ data }) => {
          context.commit(EMAIL_NOTIFICATION_PREFERENCE_SUCCESS)
          context.commit(EMAIL_NOTIFICATION_PREFERENCE_SET, data)
          context.rootState.user.userAccount.setEmailNotificationPreferences(
            data
          )
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(EMAIL_NOTIFICATION_PREFERENCE_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [EMAIL_NOTIFICATION_PREFERENCE_UPDATE_REQUEST] (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(EMAIL_NOTIFICATION_PREFERENCE_UPDATE_REQUEST)
      ApiRest()
        .put(`/email/preferences/notification`, {
          subscribed: payload.subscribed,
          hostRiskChange: payload.hostRiskChange,
          hostStatusChange: payload.hostStatusChange,
          trailAssignmentChange: payload.trailAssignmentChange,
          trailProgression: payload.trailProgression,
          trailRiskChange: payload.trailRiskChange,
          trailStatusChange: payload.trailStatusChange,
          secondaryEmails: payload.secondaryEmails
        })
        .then(resp => {
          context.commit(EMAIL_NOTIFICATION_PREFERENCE_UPDATE_SUCCESS)
          context.commit(EMAIL_NOTIFICATION_PREFERENCE_SET, resp)
          context.rootState.user.userAccount.setEmailNotificationPreferences(
            resp
          )
          resolve(resp)
        })
        .catch(errMsg => {
          context.commit(EMAIL_NOTIFICATION_PREFERENCE_UPDATE_ERROR, errMsg)
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user/notification-email-preference.module.js